/**
 * SpaceTypesFilterBar - Barra sticky de filtros por tipo de espacio
 * Permite cambiar entre tipos de espacios de forma rápida
 */
import React from 'react'
import { useTheme } from '../../hooks/useTheme'

interface SpaceTypesFilterBarProps {
  tipos: Array<{ id: string; nombre: string }>
  selectedTipoId: string | null
  onSelectTipo: (tipoSlug: string) => void
  className?: string
}

// Helper para obtener icono del tipo
const getTypeIcon = (nombre: string): string => {
  switch (nombre.toLowerCase()) {
    case 'cabaña':
    case 'cabana':
      return '🏠'
    case 'camping':
      return '⛺'
    case 'glamping':
      return '🏕️'
    case 'casa':
      return '🏡'
    case 'meson':
    case 'mesón':
      return '🍽️'
    default:
      return '🏕️'
  }
}

const SpaceTypesFilterBar: React.FC<SpaceTypesFilterBarProps> = ({
  tipos,
  selectedTipoId,
  onSelectTipo,
  className = ''
}) => {
  const { colors } = useTheme()

  if (tipos.length === 0) {
    return null
  }

  return (
    <div className={`sticky top-20 z-40 bg-white border-b shadow-md py-4 ${className}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex gap-3 overflow-x-auto scrollbar-hide pb-2">
          {tipos.map((tipo) => {
            const isSelected = selectedTipoId === tipo.id

            return (
              <button
                key={tipo.id}
                onClick={() => onSelectTipo(tipo.id)}
                className={`
                  px-6 py-2 rounded-full border-2 transition-all whitespace-nowrap font-medium
                  ${isSelected
                    ? 'text-white shadow-lg scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-50 hover:scale-102'
                  }
                `}
                style={{
                  backgroundColor: isSelected ? colors.primary : 'white',
                  borderColor: isSelected ? colors.primary : '#d1d5db',
                }}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = colors.primaryLight
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = '#d1d5db'
                  }
                }}
              >
                <span className="mr-2">{getTypeIcon(tipo.nombre)}</span>
                {tipo.nombre}
              </button>
            )
          })}
        </div>
      </div>

      {/* Hint para scroll en móvil */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  )
}

export default SpaceTypesFilterBar
